/* unplugin-vue-components disabled */import script from "./TrialFundGuideHost.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialFundGuideHost.vue?vue&type=script&setup=true&lang=js"

import "./TrialFundGuideHost.vue?vue&type=style&index=0&id=420474ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420474ac"]])

export default __exports__